export const FULFILLMENTS_DOWNSELL = '/fulfillments/downsell';
export const FULFILLMENTS_DEACTIVATE = '/api/fulfillments';

export const ENTITLEMENTS_PLAN = '/entitlements/plan';

//Flex APIs

export const UPDATE_SUBSCRIPTION_FLEX = '/entitlements/plan';

export const CANCEL_SUBSCRIPTION_IMMEDIATE_FLEX = '/entitlements/downsell';

export const GET_ENTITLEMENTS = '/entitlements?Mode=flex';
export const GET_ALL_PRODUCTS = '/entitlements/products?Mode=flex';
export const GET_IS_FLEX_USER = '/entitlements/isflex';

export const DEACTIVATE_USER = '/entitlements/deactivate';
